<form id="validateRegistrationForm" [formGroup]="validateForm" (ngSubmit)="validateRegistration()" autocomplete="off">
  <h3>{{ "i18n.base.two-factor-authentication.step-verify-registration.header" | translate }}</h3>
  <div class="form-group">
    <p>{{ "i18n.base.two-factor-authentication.step-verify-registration.description" | translate }}</p>
  </div>
  <div class="form-group">
    <label for="token">{{ "i18n.shared.two-factor-authentication-token" | translate }}</label>
    <input id="token" name="token" type="text" autocomplete="off" class="form-control" placeholder="{{ 'i18n.shared.two-factor-authentication-token' | translate }}"
      formControlName="token">
    <app-error-messages [control]="validateForm.controls.token"></app-error-messages>
  </div>
  <button type="submit" class="btn btn-primary btn-right" [disabled]="loading">
    {{ "i18n.base.two-factor-authentication.step-verify-registration.verify" | translate }}
  </button>
  <a type="button" class="btn btn-secondary btn-right me-2" (click)="goBack()">
    {{ "i18n.base.forgot-password.back-button" | translate }}
  </a>
</form>
